//VIDEO METADATA
export const PLAYER_INITALIZE = "initialize_player";
export const UPDATE_VIDEO_PREFERENCE = "update_video_preference";
